export const getLocationSearch = () => location.search;

export const getLocationPathname = () => location.pathname;

export const getLocationHash = () => location.hash;
